import { memo, useMemo } from 'react'
import './index.scss'
import { useQuery } from 'react-query'
import { getCollisions } from '../../../services/calls/mobiles'
import Table from '../../../components/Table'
import { getHistoryViewInfo } from './data'
import { useTranslation } from 'react-i18next'
import { Stop } from '..'
import { DateTime } from 'luxon'

type HistoryInfobar = {
  type: 'collisions' | 'stops'
  mobiles: number[]
  dates: { from: string, to: string }
  stops: Stop[]
}

const History__infobar = memo(({ type, mobiles, dates, stops = [] }: HistoryInfobar) => {
  const { t } = useTranslation()

  const { data: collisions } = useQuery(['getCollisions'], () => getCollisions({ mobileids: mobiles, from_datetime: dates.from, to_datetime: dates.to }))
  
  const columnInfo = useMemo(() => {
    const columns = getHistoryViewInfo(type)
    return columns
  }, [type])

  const mappedHeader = useMemo(() => {
    const lookup = {}
    if (columnInfo) {
      columnInfo.forEach((col, index) => {
        const { id } = col
        lookup[id] = {
          ...col,
          index,
          formatFunction: (val, row) => {
            if (col.type === 'date' && col.format) {
              const mDate = DateTime.fromISO(val)
              if (mDate.isValid) return mDate.toFormat(col.format)
            } else if (col.type === 'duration') {
              const hours = val > 59 ? val / 60 : 0
              const minutes = val - (60 * hours)
              let formatHours = hours
              let formatMin = minutes
              if (formatHours < 10) formatHours = `0${formatHours}`
              if (minutes < 10) formatMin = `0${formatMin}`
              return `${formatHours}:${formatMin}:00`
            }
            return val
          }
        }
      })
    }
    return lookup
  }, [columnInfo])

  const rows = useMemo(() => {
    const data = type === 'collisions' ? collisions?.[mobiles[0]].crashes : stops
    const rowArr = []
    data?.forEach((d) => {
      const newRow = { ...d }
      Object.keys(mappedHeader).map((id) => {
        const { path } = mappedHeader[id]
        const value = d[path]
        newRow[id] = value ?? ''
      })
      rowArr.push(newRow)
    })
    return rowArr
  }, [collisions, mappedHeader])

  return (
    <div className="History__infobar">
      {rows.length ? (
        <Table
          showSearch={false}
          tableHeader={mappedHeader}
          rows={rows}
        />
      ) : `${t('No')} ${type}`}
    </div>
  )
})

export default History__infobar
